/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const AccordionModule = Loadable({
  loader: () => import(/* webpackChunkName: "AccordionModule" */  '../components/AccordionModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['AccordionModule'],
  });
const AccountDetails = Loadable({
  loader: () => import(/* webpackChunkName: "AccountDetails" */  '../components/AccountDetails'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['AccountDetails'],
  });
const AccountDetailsMarketingOptOutModal = Loadable({
  loader: () => import(/* webpackChunkName: "AccountDetailsMarketingOptOutModal" */  '../components/AccountDetailsMarketingOptOutModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['AccountDetailsMarketingOptOutModal'],
  });
const ActionButton = Loadable({
  loader: () => import(/* webpackChunkName: "ActionButton" */  '../components/ActionButton'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ActionButton'],
  });
const ActionMenu = Loadable({
  loader: () => import(/* webpackChunkName: "ActionMenu" */  '../components/ActionMenu'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ActionMenu'],
  });
const AltaPayForm = Loadable({
  loader: () => import(/* webpackChunkName: "AltaPayForm" */  '../components/AltaPayForm'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['AltaPayForm'],
  });
const ArticleModule = Loadable({
  loader: () => import(/* webpackChunkName: "ArticleModule" */  '../components/ArticleModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ArticleModule'],
  });
const ArticleModuleWithMarketSupport = Loadable({
  loader: () => import(/* webpackChunkName: "ArticleModuleWithMarketSupport" */  '../components/ArticleModuleWithMarketSupport'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ArticleModuleWithMarketSupport'],
  });
const Basket = Loadable({
  loader: () => import(/* webpackChunkName: "Basket" */  '../components/Basket'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['Basket'],
  });
const Carousel = Loadable({
  loader: () => import(/* webpackChunkName: "Carousel" */  '../components/Carousel'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['Carousel'],
  });
const CategoryNavigationList = Loadable({
  loader: () => import(/* webpackChunkName: "CategoryNavigationList" */  '../components/CategoryNavigationList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['CategoryNavigationList'],
  });
const CheckoutFlowController = Loadable({
  loader: () => import(/* webpackChunkName: "CheckoutFlowController" */  '../components/CheckoutFlowController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['CheckoutFlowController'],
  });
const CheckoutFooter = Loadable({
  loader: () => import(/* webpackChunkName: "CheckoutFooter" */  '../components/CheckoutFooter'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['CheckoutFooter'],
  });
const CheckoutHeader = Loadable({
  loader: () => import(/* webpackChunkName: "CheckoutHeader" */  '../components/CheckoutHeader'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['CheckoutHeader'],
  });
const Collapsible = Loadable({
  loader: () => import(/* webpackChunkName: "Collapsible" */  '../components/Collapsible'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['Collapsible'],
  });
const ContactLinksGroup = Loadable({
  loader: () => import(/* webpackChunkName: "ContactLinksGroup" */  '../components/ContactLinksGroup'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ContactLinksGroup'],
  });
const ContactList = Loadable({
  loader: () => import(/* webpackChunkName: "ContactList" */  '../components/ContactList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ContactList'],
  });
const ContentBlock = Loadable({
  loader: () => import(/* webpackChunkName: "ContentBlock" */  '../components/ContentBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ContentBlock'],
  });
const ContentLayout = Loadable({
  loader: () => import(/* webpackChunkName: "ContentLayout" */  '../components/ContentLayout'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ContentLayout'],
  });
const ContentModal = Loadable({
  loader: () => import(/* webpackChunkName: "ContentModal" */  '../components/ContentModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ContentModal'],
  });
const CountrySelectButton = Loadable({
  loader: () => import(/* webpackChunkName: "CountrySelectButton" */  '../components/CountrySelectButton'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['CountrySelectButton'],
  });
const CountrySelector = Loadable({
  loader: () => import(/* webpackChunkName: "CountrySelector" */  '../components/CountrySelector'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['CountrySelector'],
  });
const FeatureBlock = Loadable({
  loader: () => import(/* webpackChunkName: "FeatureBlock" */  '../components/FeatureBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['FeatureBlock'],
  });
const FeatureFullWidth = Loadable({
  loader: () => import(/* webpackChunkName: "FeatureFullWidth" */  '../components/FeatureFullWidth'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['FeatureFullWidth'],
  });
const FeatureSmall = Loadable({
  loader: () => import(/* webpackChunkName: "FeatureSmall" */  '../components/FeatureSmall'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['FeatureSmall'],
  });
const FlowBoxController = Loadable({
  loader: () => import(/* webpackChunkName: "FlowBoxController" */  '../components/FlowBoxController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['FlowBoxController'],
  });
const FlowboxSlider = Loadable({
  loader: () => import(/* webpackChunkName: "FlowboxSlider" */  '../components/FlowboxSlider'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['FlowboxSlider'],
  });
const FooterLogo = Loadable({
  loader: () => import(/* webpackChunkName: "FooterLogo" */  '../components/FooterLogo'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['FooterLogo'],
  });
const HeroCover = Loadable({
  loader: () => import(/* webpackChunkName: "HeroCover" */  '../components/HeroCover'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['HeroCover'],
  });
const HeroLinear = Loadable({
  loader: () => import(/* webpackChunkName: "HeroLinear" */  '../components/HeroLinear'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['HeroLinear'],
  });
const HeroStaggered = Loadable({
  loader: () => import(/* webpackChunkName: "HeroStaggered" */  '../components/HeroStaggered'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['HeroStaggered'],
  });
const ImageGallery = Loadable({
  loader: () => import(/* webpackChunkName: "ImageGallery" */  '../components/ImageGallery'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ImageGallery'],
  });
const ImageModal = Loadable({
  loader: () => import(/* webpackChunkName: "ImageModal" */  '../components/ImageModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ImageModal'],
  });
const InfoPanel = Loadable({
  loader: () => import(/* webpackChunkName: "InfoPanel" */  '../components/InfoPanel'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['InfoPanel'],
  });
const InspirationSlider = Loadable({
  loader: () => import(/* webpackChunkName: "InspirationSlider" */  '../components/InspirationSlider'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['InspirationSlider'],
  });
const InvoiceList = Loadable({
  loader: () => import(/* webpackChunkName: "InvoiceList" */  '../components/InvoiceList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['InvoiceList'],
  });
const LinkWrapper = Loadable({
  loader: () => import(/* webpackChunkName: "LinkWrapper" */  '../components/LinkWrapper'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['LinkWrapper'],
  });
const ListHero = Loadable({
  loader: () => import(/* webpackChunkName: "ListHero" */  '../components/ListHero'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ListHero'],
  });
const ListTitle = Loadable({
  loader: () => import(/* webpackChunkName: "ListTitle" */  '../components/ListTitle'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ListTitle'],
  });
const LoadingDots = Loadable({
  loader: () => import(/* webpackChunkName: "LoadingDots" */  '../components/LoadingDots'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['LoadingDots'],
  });
const LoginModule = Loadable({
  loader: () => import(/* webpackChunkName: "LoginModule" */  '../components/LoginModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['LoginModule'],
  });
const LogoAnimation = Loadable({
  loader: () => import(/* webpackChunkName: "LogoAnimation" */  '../components/LogoAnimation'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['LogoAnimation'],
  });
const MainFooter = Loadable({
  loader: () => import(/* webpackChunkName: "MainFooter" */  '../components/MainFooter'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MainFooter'],
  });
const MarketChangeModal = Loadable({
  loader: () => import(/* webpackChunkName: "MarketChangeModal" */  '../components/MarketChangeModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MarketChangeModal'],
  });
const MaterialInfoOverlay = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialInfoOverlay" */  '../components/MaterialInfoOverlay'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialInfoOverlay'],
  });
const MaterialListController = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialListController" */  '../components/MaterialListController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialListController'],
  });
const MaterialProductSliderController = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialProductSliderController" */  '../components/MaterialProductSliderController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialProductSliderController'],
  });
const MaterialSetListController = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialSetListController" */  '../components/MaterialSetListController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialSetListController'],
  });
const MaterialSetProductSliderController = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialSetProductSliderController" */  '../components/MaterialSetProductSliderController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialSetProductSliderController'],
  });
const MaterialSetTile = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialSetTile" */  '../components/MaterialSetTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialSetTile'],
  });
const MaterialTile = Loadable({
  loader: () => import(/* webpackChunkName: "MaterialTile" */  '../components/MaterialTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MaterialTile'],
  });
const MediaFocal = Loadable({
  loader: () => import(/* webpackChunkName: "MediaFocal" */  '../components/MediaFocal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MediaFocal'],
  });
const MediaInfoOverlay = Loadable({
  loader: () => import(/* webpackChunkName: "MediaInfoOverlay" */  '../components/MediaInfoOverlay'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MediaInfoOverlay'],
  });
const MenuOverlay = Loadable({
  loader: () => import(/* webpackChunkName: "MenuOverlay" */  '../components/MenuOverlay'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MenuOverlay'],
  });
const MessageBlock = Loadable({
  loader: () => import(/* webpackChunkName: "MessageBlock" */  '../components/MessageBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MessageBlock'],
  });
const MicroTileGrid = Loadable({
  loader: () => import(/* webpackChunkName: "MicroTileGrid" */  '../components/MicroTileGrid'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MicroTileGrid'],
  });
const ModalOverlay = Loadable({
  loader: () => import(/* webpackChunkName: "ModalOverlay" */  '../components/ModalOverlay'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ModalOverlay'],
  });
const ModeSwitch = Loadable({
  loader: () => import(/* webpackChunkName: "ModeSwitch" */  '../components/ModeSwitch'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ModeSwitch'],
  });
const MyFritzHansenInfoModal = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenInfoModal" */  '../components/MyFritzHansenInfoModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenInfoModal'],
  });
const MyFritzHansenInvoiceModal = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenInvoiceModal" */  '../components/MyFritzHansenInvoiceModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenInvoiceModal'],
  });
const MyFritzHansenProductList = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenProductList" */  '../components/MyFritzHansenProductList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenProductList'],
  });
const MyFritzHansenProductModal = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenProductModal" */  '../components/MyFritzHansenProductModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenProductModal'],
  });
const MyFritzHansenRegisterProduct = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenRegisterProduct" */  '../components/MyFritzHansenRegisterProduct'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenRegisterProduct'],
  });
const MyFritzHansenRegisterProductModal = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenRegisterProductModal" */  '../components/MyFritzHansenRegisterProductModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenRegisterProductModal'],
  });
const MyFritzHansenTile = Loadable({
  loader: () => import(/* webpackChunkName: "MyFritzHansenTile" */  '../components/MyFritzHansenTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['MyFritzHansenTile'],
  });
const NavButton = Loadable({
  loader: () => import(/* webpackChunkName: "NavButton" */  '../components/NavButton'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavButton'],
  });
const NavHighlightBlock = Loadable({
  loader: () => import(/* webpackChunkName: "NavHighlightBlock" */  '../components/NavHighlightBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavHighlightBlock'],
  });
const NavList = Loadable({
  loader: () => import(/* webpackChunkName: "NavList" */  '../components/NavList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavList'],
  });
const NavListButton = Loadable({
  loader: () => import(/* webpackChunkName: "NavListButton" */  '../components/NavListButton'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavListButton'],
  });
const NavModule = Loadable({
  loader: () => import(/* webpackChunkName: "NavModule" */  '../components/NavModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavModule'],
  });
const NavPanel = Loadable({
  loader: () => import(/* webpackChunkName: "NavPanel" */  '../components/NavPanel'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavPanel'],
  });
const NavPanelsBlock = Loadable({
  loader: () => import(/* webpackChunkName: "NavPanelsBlock" */  '../components/NavPanelsBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavPanelsBlock'],
  });
const NavTile = Loadable({
  loader: () => import(/* webpackChunkName: "NavTile" */  '../components/NavTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavTile'],
  });
const NavTilesBlock = Loadable({
  loader: () => import(/* webpackChunkName: "NavTilesBlock" */  '../components/NavTilesBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavTilesBlock'],
  });
const NavTilesSliderController = Loadable({
  loader: () => import(/* webpackChunkName: "NavTilesSliderController" */  '../components/NavTilesSliderController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NavTilesSliderController'],
  });
const NewsletterSignUp = Loadable({
  loader: () => import(/* webpackChunkName: "NewsletterSignUp" */  '../components/NewsletterSignUp'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NewsletterSignUp'],
  });
const NotifyMeOverlay = Loadable({
  loader: () => import(/* webpackChunkName: "NotifyMeOverlay" */  '../components/NotifyMeOverlay'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['NotifyMeOverlay'],
  });
const OrderCalculation = Loadable({
  loader: () => import(/* webpackChunkName: "OrderCalculation" */  '../components/OrderCalculation'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['OrderCalculation'],
  });
const OutOfStockModal = Loadable({
  loader: () => import(/* webpackChunkName: "OutOfStockModal" */  '../components/OutOfStockModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['OutOfStockModal'],
  });
const PDPController = Loadable({
  loader: () => import(/* webpackChunkName: "PDPController" */  '../components/PDPController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['PDPController'],
  });
const PDPRelatedProducts = Loadable({
  loader: () => import(/* webpackChunkName: "PDPRelatedProducts" */  '../components/PDPRelatedProducts'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['PDPRelatedProducts'],
  });
const PageErrorBlock = Loadable({
  loader: () => import(/* webpackChunkName: "PageErrorBlock" */  '../components/PageErrorBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['PageErrorBlock'],
  });
const PageSiblings = Loadable({
  loader: () => import(/* webpackChunkName: "PageSiblings" */  '../components/PageSiblings'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['PageSiblings'],
  });
const PortfolioLayoutController = Loadable({
  loader: () => import(/* webpackChunkName: "PortfolioLayoutController" */  '../components/PortfolioLayoutController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['PortfolioLayoutController'],
  });
const PresentationModal = Loadable({
  loader: () => import(/* webpackChunkName: "PresentationModal" */  '../components/PresentationModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['PresentationModal'],
  });
const ProductFiltersBlock = Loadable({
  loader: () => import(/* webpackChunkName: "ProductFiltersBlock" */  '../components/ProductFiltersBlock'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductFiltersBlock'],
  });
const ProductFiltersList = Loadable({
  loader: () => import(/* webpackChunkName: "ProductFiltersList" */  '../components/ProductFiltersList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductFiltersList'],
  });
const ProductFiltersVisual = Loadable({
  loader: () => import(/* webpackChunkName: "ProductFiltersVisual" */  '../components/ProductFiltersVisual'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductFiltersVisual'],
  });
const ProductImage = Loadable({
  loader: () => import(/* webpackChunkName: "ProductImage" */  '../components/ProductImage'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductImage'],
  });
const ProductLine = Loadable({
  loader: () => import(/* webpackChunkName: "ProductLine" */  '../components/ProductLine'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductLine'],
  });
const ProductListController = Loadable({
  loader: () => import(/* webpackChunkName: "ProductListController" */  '../components/ProductListController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductListController'],
  });
const ProductPrice = Loadable({
  loader: () => import(/* webpackChunkName: "ProductPrice" */  '../components/ProductPrice'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductPrice'],
  });
const ProductSeriesSlider = Loadable({
  loader: () => import(/* webpackChunkName: "ProductSeriesSlider" */  '../components/ProductSeriesSlider'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductSeriesSlider'],
  });
const ProductSeriesTile = Loadable({
  loader: () => import(/* webpackChunkName: "ProductSeriesTile" */  '../components/ProductSeriesTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductSeriesTile'],
  });
const ProductTile = Loadable({
  loader: () => import(/* webpackChunkName: "ProductTile" */  '../components/ProductTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductTile'],
  });
const ProductTilesSlider = Loadable({
  loader: () => import(/* webpackChunkName: "ProductTilesSlider" */  '../components/ProductTilesSlider'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductTilesSlider'],
  });
const ProductTilesSliderController = Loadable({
  loader: () => import(/* webpackChunkName: "ProductTilesSliderController" */  '../components/ProductTilesSliderController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ProductTilesSliderController'],
  });
const QRCodeModal = Loadable({
  loader: () => import(/* webpackChunkName: "QRCodeModal" */  '../components/QRCodeModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['QRCodeModal'],
  });
const QuoteModule = Loadable({
  loader: () => import(/* webpackChunkName: "QuoteModule" */  '../components/QuoteModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['QuoteModule'],
  });
const RawHTMLModule = Loadable({
  loader: () => import(/* webpackChunkName: "RawHTMLModule" */  '../components/RawHTMLModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['RawHTMLModule'],
  });
const ReferencesController = Loadable({
  loader: () => import(/* webpackChunkName: "ReferencesController" */  '../components/ReferencesController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['ReferencesController'],
  });
const RichTextModule = Loadable({
  loader: () => import(/* webpackChunkName: "RichTextModule" */  '../components/RichTextModule'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['RichTextModule'],
  });
const SearchPageController = Loadable({
  loader: () => import(/* webpackChunkName: "SearchPageController" */  '../components/SearchPageController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SearchPageController'],
  });
const SimpleGallery = Loadable({
  loader: () => import(/* webpackChunkName: "SimpleGallery" */  '../components/SimpleGallery'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SimpleGallery'],
  });
const SimpleTagList = Loadable({
  loader: () => import(/* webpackChunkName: "SimpleTagList" */  '../components/SimpleTagList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SimpleTagList'],
  });
const SiteFooter = Loadable({
  loader: () => import(/* webpackChunkName: "SiteFooter" */  '../components/SiteFooter'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SiteFooter'],
  });
const SiteHeader = Loadable({
  loader: () => import(/* webpackChunkName: "SiteHeader" */  '../components/SiteHeader'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SiteHeader'],
  });
const Spacer = Loadable({
  loader: () => import(/* webpackChunkName: "Spacer" */  '../components/Spacer'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['Spacer'],
  });
const SpotTile = Loadable({
  loader: () => import(/* webpackChunkName: "SpotTile" */  '../components/SpotTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SpotTile'],
  });
const StatusBar = Loadable({
  loader: () => import(/* webpackChunkName: "StatusBar" */  '../components/StatusBar'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['StatusBar'],
  });
const StoreLocatorController = Loadable({
  loader: () => import(/* webpackChunkName: "StoreLocatorController" */  '../components/StoreLocatorController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['StoreLocatorController'],
  });
const StoriesController = Loadable({
  loader: () => import(/* webpackChunkName: "StoriesController" */  '../components/StoriesController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['StoriesController'],
  });
const SubNavigation = Loadable({
  loader: () => import(/* webpackChunkName: "SubNavigation" */  '../components/SubNavigation'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['SubNavigation'],
  });
const TagList = Loadable({
  loader: () => import(/* webpackChunkName: "TagList" */  '../components/TagList'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['TagList'],
  });
const TagListButton = Loadable({
  loader: () => import(/* webpackChunkName: "TagListButton" */  '../components/TagListButton'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['TagListButton'],
  });
const TextTile = Loadable({
  loader: () => import(/* webpackChunkName: "TextTile" */  '../components/TextTile'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['TextTile'],
  });
const TimelineController = Loadable({
  loader: () => import(/* webpackChunkName: "TimelineController" */  '../components/TimelineController'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['TimelineController'],
  });
const TrustPilotScript = Loadable({
  loader: () => import(/* webpackChunkName: "TrustPilotScript" */  '../components/TrustPilotScript'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['TrustPilotScript'],
  });
const UniqueMaterialUnavailableModal = Loadable({
  loader: () => import(/* webpackChunkName: "UniqueMaterialUnavailableModal" */  '../components/UniqueMaterialUnavailableModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['UniqueMaterialUnavailableModal'],
  });
const VideoPlayerModal = Loadable({
  loader: () => import(/* webpackChunkName: "VideoPlayerModal" */  '../components/VideoPlayerModal'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['VideoPlayerModal'],
  });
const VisionSlider = Loadable({
  loader: () => import(/* webpackChunkName: "VisionSlider" */  '../components/VisionSlider'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['VisionSlider'],
  });
const VisionSliderSlide = Loadable({
  loader: () => import(/* webpackChunkName: "VisionSliderSlide" */  '../components/VisionSliderSlide'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['VisionSliderSlide'],
  });
const pdp = Loadable({
  loader: () => import(/* webpackChunkName: "pdp" */  '../components/pdp'), // do not use gready module loader /* webpackPrefetch: true */ it is too hard on mobile
  loading: () => <div></div>,
  modules: ['pdp'],
  });

const components = new Map();
components.set('AccordionModule', AccordionModule);
components.set('AccountDetails', AccountDetails);
components.set('AccountDetailsMarketingOptOutModal', AccountDetailsMarketingOptOutModal);
components.set('ActionButton', ActionButton);
components.set('ActionMenu', ActionMenu);
components.set('AltaPayForm', AltaPayForm);
components.set('ArticleModule', ArticleModule);
components.set('ArticleModuleWithMarketSupport', ArticleModuleWithMarketSupport);
components.set('Basket', Basket);
components.set('Carousel', Carousel);
components.set('CategoryNavigationList', CategoryNavigationList);
components.set('CheckoutFlowController', CheckoutFlowController);
components.set('CheckoutFooter', CheckoutFooter);
components.set('CheckoutHeader', CheckoutHeader);
components.set('Collapsible', Collapsible);
components.set('ContactLinksGroup', ContactLinksGroup);
components.set('ContactList', ContactList);
components.set('ContentBlock', ContentBlock);
components.set('ContentLayout', ContentLayout);
components.set('ContentModal', ContentModal);
components.set('CountrySelectButton', CountrySelectButton);
components.set('CountrySelector', CountrySelector);
components.set('FeatureBlock', FeatureBlock);
components.set('FeatureFullWidth', FeatureFullWidth);
components.set('FeatureSmall', FeatureSmall);
components.set('FlowBoxController', FlowBoxController);
components.set('FlowboxSlider', FlowboxSlider);
components.set('FooterLogo', FooterLogo);
components.set('HeroCover', HeroCover);
components.set('HeroLinear', HeroLinear);
components.set('HeroStaggered', HeroStaggered);
components.set('ImageGallery', ImageGallery);
components.set('ImageModal', ImageModal);
components.set('InfoPanel', InfoPanel);
components.set('InspirationSlider', InspirationSlider);
components.set('InvoiceList', InvoiceList);
components.set('LinkWrapper', LinkWrapper);
components.set('ListHero', ListHero);
components.set('ListTitle', ListTitle);
components.set('LoadingDots', LoadingDots);
components.set('LoginModule', LoginModule);
components.set('LogoAnimation', LogoAnimation);
components.set('MainFooter', MainFooter);
components.set('MarketChangeModal', MarketChangeModal);
components.set('MaterialInfoOverlay', MaterialInfoOverlay);
components.set('MaterialListController', MaterialListController);
components.set('MaterialProductSliderController', MaterialProductSliderController);
components.set('MaterialSetListController', MaterialSetListController);
components.set('MaterialSetProductSliderController', MaterialSetProductSliderController);
components.set('MaterialSetTile', MaterialSetTile);
components.set('MaterialTile', MaterialTile);
components.set('MediaFocal', MediaFocal);
components.set('MediaInfoOverlay', MediaInfoOverlay);
components.set('MenuOverlay', MenuOverlay);
components.set('MessageBlock', MessageBlock);
components.set('MicroTileGrid', MicroTileGrid);
components.set('ModalOverlay', ModalOverlay);
components.set('ModeSwitch', ModeSwitch);
components.set('MyFritzHansenInfoModal', MyFritzHansenInfoModal);
components.set('MyFritzHansenInvoiceModal', MyFritzHansenInvoiceModal);
components.set('MyFritzHansenProductList', MyFritzHansenProductList);
components.set('MyFritzHansenProductModal', MyFritzHansenProductModal);
components.set('MyFritzHansenRegisterProduct', MyFritzHansenRegisterProduct);
components.set('MyFritzHansenRegisterProductModal', MyFritzHansenRegisterProductModal);
components.set('MyFritzHansenTile', MyFritzHansenTile);
components.set('NavButton', NavButton);
components.set('NavHighlightBlock', NavHighlightBlock);
components.set('NavList', NavList);
components.set('NavListButton', NavListButton);
components.set('NavModule', NavModule);
components.set('NavPanel', NavPanel);
components.set('NavPanelsBlock', NavPanelsBlock);
components.set('NavTile', NavTile);
components.set('NavTilesBlock', NavTilesBlock);
components.set('NavTilesSliderController', NavTilesSliderController);
components.set('NewsletterSignUp', NewsletterSignUp);
components.set('NotifyMeOverlay', NotifyMeOverlay);
components.set('OrderCalculation', OrderCalculation);
components.set('OutOfStockModal', OutOfStockModal);
components.set('PDPController', PDPController);
components.set('PDPRelatedProducts', PDPRelatedProducts);
components.set('PageErrorBlock', PageErrorBlock);
components.set('PageSiblings', PageSiblings);
components.set('PortfolioLayoutController', PortfolioLayoutController);
components.set('PresentationModal', PresentationModal);
components.set('ProductFiltersBlock', ProductFiltersBlock);
components.set('ProductFiltersList', ProductFiltersList);
components.set('ProductFiltersVisual', ProductFiltersVisual);
components.set('ProductImage', ProductImage);
components.set('ProductLine', ProductLine);
components.set('ProductListController', ProductListController);
components.set('ProductPrice', ProductPrice);
components.set('ProductSeriesSlider', ProductSeriesSlider);
components.set('ProductSeriesTile', ProductSeriesTile);
components.set('ProductTile', ProductTile);
components.set('ProductTilesSlider', ProductTilesSlider);
components.set('ProductTilesSliderController', ProductTilesSliderController);
components.set('QRCodeModal', QRCodeModal);
components.set('QuoteModule', QuoteModule);
components.set('RawHTMLModule', RawHTMLModule);
components.set('ReferencesController', ReferencesController);
components.set('RichTextModule', RichTextModule);
components.set('SearchPageController', SearchPageController);
components.set('SimpleGallery', SimpleGallery);
components.set('SimpleTagList', SimpleTagList);
components.set('SiteFooter', SiteFooter);
components.set('SiteHeader', SiteHeader);
components.set('Spacer', Spacer);
components.set('SpotTile', SpotTile);
components.set('StatusBar', StatusBar);
components.set('StoreLocatorController', StoreLocatorController);
components.set('StoriesController', StoriesController);
components.set('SubNavigation', SubNavigation);
components.set('TagList', TagList);
components.set('TagListButton', TagListButton);
components.set('TextTile', TextTile);
components.set('TimelineController', TimelineController);
components.set('TrustPilotScript', TrustPilotScript);
components.set('UniqueMaterialUnavailableModal', UniqueMaterialUnavailableModal);
components.set('VideoPlayerModal', VideoPlayerModal);
components.set('VisionSlider', VisionSlider);
components.set('VisionSliderSlide', VisionSliderSlide);
components.set('pdp', pdp);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
